const AvatarSize = {
    Small: 24,
    Medium: 32,
    Large: 40,
    XLarge: 72
};

const AvatarShape = {
    RoundedSquare: 1,
    Circle: 2
};

export { AvatarShape, AvatarSize };
